export enum OrderStatus {
  Processing = 'processing',
  Paid = 'paid',
  Unpaid = 'unpaid',
  Canceled = 'canceled',
  Expired = 'expired',
  Failed = 'failed',
  Refunded = 'refunded',
}
